import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-helpbutton-department-resume-card',
  templateUrl: './helpbutton-department-resume-card.component.html',
  styleUrls: ['./helpbutton-department-resume-card.component.scss']
})
export class HelpbuttonDepartmentResumeCardComponent implements OnInit, OnDestroy {

  @Input() department;
  @Input() viewDisposition;
  centerList;
  deleteDepartmentSubscribe: Subscription;

  constructor(private router: Router,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService,
    private departmentsService: DepartmentsHelpbuttonService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['/helpbutton/department', this.department.InternalId]);
    }
  }

  public deleteDepartment() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['helpbutton-page.delete department', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteDepartmentSubscribe = this.departmentsService.deleteDepartment(this.department.InternalId).subscribe(
          (res) => {
            if (res['data']['success']) {
              this.departmentsService.refreshDepartments();
            } else {
              this.snackbarService.open('Cant be deleted', 'error');
            }
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public getCenter() {
    if (this.department && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.department.CenterInternalId) {
          return center.CenterName;
        }
      }
    } else {
      return '-';
    }
  }

  ngOnDestroy() {
    if (this.deleteDepartmentSubscribe) { this.deleteDepartmentSubscribe.unsubscribe(); }
  }

}
